import type { LDFlagSet } from 'launchdarkly-js-client-sdk';
import type { LDContext } from 'launchdarkly-react-client-sdk/lib/context';
import { Provider as LdProvider } from 'launchdarkly-react-client-sdk/lib/context';
import type { ReactElement, ReactNode } from 'react';

import { FakeLaunchDarklyClient } from './Client';

interface IFakeLaunchDarklyFlagContextProvider {
  /** Optional feature flag values to set. e.g. {myFeatureFlag: true}.  */
  flags?: LDFlagSet;
  /** Optional user for this context. */
  user?: { key: string };
  children: ReactNode;
}

export const FakeLaunchDarklyFlagContextProvider = (
  props: IFakeLaunchDarklyFlagContextProvider
): ReactElement => {
  const { flags = {}, user = { key: 'fake-ld-flag-provider-user' }, children } = props;

  // We have to do all this because LaunchDarkly doesn't make it easy to get at
  // the LDContext and make what you want when you're camelCasing flags. There's
  // a ticket about this
  // https://github.com/launchdarkly/react-client-sdk/issues/30 and specifically
  // a comment asking for what we would prefer from their API
  // https://github.com/launchdarkly/react-client-sdk/issues/30#issuecomment-825042690
  const fakeLdContext: LDContext = {
    flags,
    flagKeyMap: {},
    ldClient: new FakeLaunchDarklyClient(flags, user),
  };

  return <LdProvider value={fakeLdContext}>{children}</LdProvider>;
};
